import { logError, logEvent, logCustomAttributes } from './logging.js';
import { cohesionReady, cohesionCatch } from './cohesionEvents.js';

// Monarch 'done' is fired after the Monarch native auto call is finished
// Future add of monitoring for manual monarch requests if applicable
const monarchDone = (err, evaluation) => {
  if (err) {
    const errString = JSON.stringify(err);
    logError(`autoMonarch:error ${errString}`);
    logEvent('autoMonarch:error', {
      error: errString
    });
  } else {
    const evaluationResult = evaluation?.source?.trafficFlow;
    const evaluationValue = evaluation?.source?.trafficFlow?.value;
    if (evaluationValue) {
      let audienceName = evaluationResult?.audienceName || '';
      // In a Monarch returned Preamp Connection Experience, the experienceName is listed under the key 'name'
      // In a Monarch returned Monarch experience, it is listed under the key 'experienceName'
      // Checking both keys to ensure we capture the experienceName in both cases
      let experienceName = evaluationValue?.experienceName || evaluationValue?.name || '';
      let experienceNumber = evaluationValue?.experienceNumber || '';
      let experimentName = evaluationResult?.experimentName || '';
      if (evaluationResult?.isPreview) {
        audienceName = '';
        experienceName = 'Preview';
        experienceNumber = -1;
        experimentName = '';
      }

      // Send attributes to New Relic
      logCustomAttributes([{
        name: `autoMonarch.experienceName`,
        value: experienceName
      }, {
        name: `autoMonarch.experienceNumber`,
        value: experienceNumber
      }, {
        name: 'cohesion.audience',
        value: audienceName
      }, {
        name: 'cohesion.experienceName',
        value: experienceName
      }, {
        name: 'cohesion.experience',
        value: `${experienceNumber}`
      }, {
        name: 'cohesion.experimentName',
        value: experimentName
      }, {
        name: 'cohesion.renderedExperienceSource',
        value: 'autoMonarch'
      }]);
      logEvent('autoMonarch:evaluationReceived', {
        experienceValues: evaluationValue?.experienceValues?.length
      });
    }
    logEvent('autoMonarch:done');
  }
};
const monitorOnError = () => {
  console.error('Cohesion script - failed to load');
  logError(`cohesion:script: failed to load`);
};
const setMonarchMonitoring = _ref => {
  let {
    hasUpdatedSnippet = false
  } = _ref;
  try {
    // Send a page action to new relic when cohesion is ready.
    window?.cohesion('ready', cohesionReady);

    // Event listener that will listen for Monarch to be done loading
    window?.cohesion('monarch:done', (err, evaluation) => {
      monarchDone(err, evaluation);
    });

    // Event listener that will listen for any errors that occur in while loading the Cohesion snippet
    // This event is only available using the new Cohesion snippet that has built in error handling so we will
    // need to listen to the event separately to add our monitoring to errors
    hasUpdatedSnippet && window?.cohesion('error', monitorOnError);
  } catch (error) {
    cohesionCatch(error);
  }
};

export { monarchDone, monitorOnError, setMonarchMonitoring };
